import { useSyncExternalStore } from "react";
import { addHours, formatISO, startOfHour } from "date-fns";
import { getLocalTodayDateOnly } from "@helpers/date";

const msUntilNextHour = () => {
    const now = new Date();
    return startOfHour(addHours(now, 1)).getTime() - now.getTime();
};

/** Tab returns and the top of every hour, so a page left in front keeps up with the clock. */
const subscribeToClock = (onChange: () => void) => {
    let timeout: ReturnType<typeof setTimeout>;
    const scheduleNextHour = () => {
        timeout = setTimeout(() => {
            onChange();
            scheduleNextHour();
        }, msUntilNextHour());
    };
    scheduleNextHour();
    document.addEventListener("visibilitychange", onChange);
    window.addEventListener("focus", onChange);
    return () => {
        clearTimeout(timeout);
        document.removeEventListener("visibilitychange", onChange);
        window.removeEventListener("focus", onChange);
    };
};

const getLocalCurrentHour = () => formatISO(startOfHour(new Date()));

/** The viewer's today, read again when the tab comes back and at each hour, so a page left open past midnight moves to the new day. */
export const useToday = (): string =>
    useSyncExternalStore(subscribeToClock, getLocalTodayDateOnly);

/** The start of the viewer's current hour as an ISO timestamp, read again when the tab comes back and at the top of each hour. */
export const useCurrentHour = (): string =>
    useSyncExternalStore(subscribeToClock, getLocalCurrentHour);
